// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";

import crossIcon from "../images/Incorrect.svg"
import CorrectIcon from "../images/CorrectIcon.svg"
import Incorrect from "../images/graphIcons/incorrect.svg"

import Graph1 from "./Question3Graphs/Graph1";
import Graph2 from "./Question3Graphs/Graph2";
import Labels2 from "./Question3Graphs/Labels2";
import Labels1 from "./Question3Graphs/Labels1";
import DescriptionLines from "./DescriptionLines";
import EvaluatorModal from "./EvaluatorModal";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile } from "react-device-detect";
import { Grid } from "@material-ui/core";

import styles from "./styles";
import "animate.css/animate.css";

function Question3(props) {
  const [inPe, setInPe] =useState(false)
  const [inQe, setInQe] =useState(false)
  const [inQt, setInQt] =useState(false)
  const [inPb, setInPb] =useState(false)
  const [inPs, setInPs] =useState(false)
  const [peLabel, setPeLabel] =useState("")
  const [qeLabel, setQeLabel] =useState("")
  const [qtLabel, setQtLabel] =useState("")
  const [pbLabel, setPbLabel] =useState("")
  const [psLabel, setPsLabel] =useState("")
  const [step, setStep] =useState(0)
  const [isOpen, setIsOpen] =useState(false)
  const [allCorrect, setAllCorrect] =useState(false)
  const [draggableLabel, setDraggableLabel] =useState("")
  const [draggedLabels, setDraggedLabels] =useState([])
  // descriptionLines states
  const [buyerTax, setBuyerTax] = useState(0)
  const [sellerTax, setSellerTax] = useState(0)
  const [isYes, setIsYes] = useState(0)
  const [isNo, setIsNo] = useState(0)
  const [governmentRevenue, setGovernmentRevenue] = useState(0)
  const [selected, setSelected] = useState([]);
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const { qIndex, descriptionText, questionNumber, questionAnswer, setAnswers, answers, handleReloadClick, classes } = props;

  const PeRef = useRef(null);
  const QeRef = useRef(null);
  const QtRef = useRef(null);
  const PbRef = useRef(null);
  const PsRef = useRef(null);

  const [submit, setSubmit] =useState(false)

  useEffect(() => {
    if(submit === true){
      if(step === 0){
        setAllCorrect(peLabel === "Pe" && qeLabel === "Qe")
      }
      else if(step === 2){
        setAllCorrect(peLabel === "Pe" && qeLabel === "Qe" && qtLabel === "Qt" && pbLabel === "Pb" && psLabel === "Ps")
      }else if(step === 6){
        setAllCorrect(buyerTax === descriptionText.buyerTax && sellerTax === descriptionText.sellerTax && isYes === false)
      }else if(step === 1 || step === 7){
        let arraysMatch = selected.length === questionAnswer.answer.length && selected.every((value, index) =>  questionAnswer.answer.includes(value));
        questionAnswer.index === 2 ?
          setAllCorrect(governmentRevenue === questionAnswer.numberAnswer && arraysMatch)
          : setAllCorrect(arraysMatch)
      }
    }
  },[submit])

  const graph1Ref = useRef(null);
  const graph2Ref = useRef(null);

  const clearScreen = () => {
    setInPe(false)
    setInQe(false)
    setInQt(false)
    setInPb(false)
    setInPs(false)
    setPeLabel("")
    setQeLabel("")
    setQtLabel("")
    setPbLabel("")
    setPsLabel("")
    setSelected([])
    setDraggableLabel("")
    setDraggedLabels([])
    setSubmit(false)
    setBuyerTax(0)
    setGovernmentRevenue(0)
    setIsYes(0)
    setIsNo(0)
    setSellerTax(0)
    if(step >= 2){
      graph2Ref.current()
    }else{
      graph1Ref.current()
    }
  }


  useEffect(() => {
    // localStorage.setItem('step', 0)
    // setScreenSize(window.innerWidth)

    const handleResize = () => {
      console.log("window.innerWidth", window.innerWidth) 
      setScreenSize(window.innerWidth);
    };

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, [])

  function getLabeltext() {
    if(step === 0){
      if(peLabel === "" && qeLabel === ""){
        return "You forgot to place the Pe, Qe labels."
      }
      else if((peLabel === "" || qeLabel === "")){
        return "You forgot to place a label."
      }
      else if(peLabel !== "Pe" || qeLabel !== "Qe"){
        return "You placed at least one label incorrectly."
      }
    }else if(step === 2){
      if(peLabel === "" && qeLabel === "" && qtLabel === "" && pbLabel === "" && psLabel === ""){
        return "You forgot to place the Pe, Qe, Qt, Pb and Ps labels."
      }
      else if((peLabel === "" || qeLabel === "" || qtLabel === "" || pbLabel === "" || psLabel === "")){
        return "You forgot to place a label."
      }
      else if(peLabel !== "Pe" || qeLabel !== "Qe" || qtLabel !== "Qt" || pbLabel !== "Pb" || psLabel !== "Ps"){
        return "You placed at least one label incorrectly."
      }
    }
    else if([1,7].includes(step) && !allCorrect){
      return selected.length === 0 ? "You forgot to select an area on the graph." : "You made an error."
    }
    // else if(!allCorrect){
    //   return "You made an error."
    // }
  }

  function getAnswertext() {
    // let dots = answerCoordinates.length - 1
    // if(dots === 0){
    //   return "You forgot to place the dots on the Demand Curve graph."
    // }
    // else if(dots < 3){
    //   return "You didn't place all the dots."
    // }
    // else if(dots >= 3 && !allCorrect){
    //   return "You placed the dots incorrectly."
    // }
  }

  function getButtonText() {
    if(submit){
      return (step === 0 || step === 2 ) && !allCorrect ? "TRY AGAIN" : "NEXT"
    }else{
      return "SUBMIT"
    }
  }

  function nextStep(){
    if(questionAnswer.index === 1){
      setPeLabel("")
      setQeLabel("")
      setDraggedLabels([])
    }

    if(step !== 7 && step !== 1){
      setStep(step+1)
      // setStep(5)
      // localStorage.setItem('step', 5)
    }else{
      if(questionAnswer.index === 1){
        setStep(step+1)
      }
      setSubmit(false)
      setGovernmentRevenue(0)
      handleReloadClick()
      // step !== 5 && setSubmit(false)
    }
  }

  const onDragEnd = () => {
    // setDragState();

    if (!inPe && !inQe && !inQt && !inPb && !inPs) return;

    if (inPe) {
      updateDraggedLabels(peLabel)
      setPeLabel(draggableLabel)
    } else if (inQe) {
      updateDraggedLabels(qeLabel)
      setQeLabel(draggableLabel)
    }else if (inQt) {
      updateDraggedLabels(qtLabel)
      setQtLabel(draggableLabel)
    }else if (inPb) {
      updateDraggedLabels(pbLabel)
      setPbLabel(draggableLabel)
    }else if (inPs) {
      updateDraggedLabels(psLabel)
      setPsLabel(draggableLabel)
    }
    // let tempLabels = draggedLabels
    // tempLabels.push(draggableLabel)
    // setDraggedLabels(tempLabels)
    setInPe(false);
    setInQe(false);
    setInQt(false);
    setInPb(false);
    setInPs(false);
  };

  const updateDraggedLabels = (label) => {
    const updatedLabels = draggedLabels.filter(item => item !== label);
    if(label.length > 0){
      setDraggedLabels(updatedLabels);
    }
    updatedLabels.push(draggableLabel)
    setDraggedLabels(updatedLabels)
  }

  const onDragOffEnd = (offLabel, removeFrom, startLabel) => {
    if (!inPe && !inQe && !inQt && !inPb && !inPs){
      const updatedLabels = draggedLabels.filter(item => item !== offLabel);
      setDraggedLabels(updatedLabels);
      if (removeFrom === "Pe") {
        setPeLabel("")
      } else if (removeFrom === "Qe") {
        setQeLabel('')
      }else if (removeFrom === "Qt") {
        setQtLabel('')
      }else if (removeFrom === "Pb") {
        setPbLabel('')
      }else if (removeFrom === "Ps") {
        setPsLabel('')
      }
      return
    }
    console.log("offLabel", offLabel, removeFrom, startLabel)

    if(startLabel){
      removeFromDropable(startLabel)
    }

    if (inPe) {
      updateDraggedOffLabels(peLabel, offLabel)
      setPeLabel(offLabel)
    } else if (inQe) {
      updateDraggedOffLabels(qeLabel, offLabel)
      setQeLabel(offLabel)
    }else if (inQt) {
      updateDraggedOffLabels(qtLabel, offLabel)
      setQtLabel(offLabel)
    }else if (inPb) {
      updateDraggedOffLabels(pbLabel, offLabel)
      setPbLabel(offLabel)
    }else if (inPs) {
      updateDraggedOffLabels(psLabel, offLabel)
      setPsLabel(offLabel)
    }
    // let tempLabels = draggedLabels
    // tempLabels.push(draggableLabel)
    // setDraggedLabels(tempLabels)
    setInPe(false);
    setInQe(false);
    setInQt(false);
    setInPb(false);
    setInPs(false);
  };

  const updateDraggedOffLabels = (label, startlabel) => {
    const updatedLabels = draggedLabels.filter(item => item !== label);
    if(label.length > 0){
      setDraggedLabels(updatedLabels);
    }
    updatedLabels.push(startlabel)
    setDraggedLabels(updatedLabels)
  }

  const removeFromDropable = (removeFrom) => {
    if (removeFrom === "Pe") {
      setPeLabel('')
    } else if (removeFrom === "Qe") {
      setQeLabel('')
    }else if (removeFrom === "Qt") {
      setQtLabel('')
    }else if (removeFrom === "Pb") {
      setPbLabel('')
    }else if (removeFrom === "Ps") {
      setPsLabel('')
    }
  }

  const onDragOffUpdate = (e, data) => {
    e.preventDefault()
    console.log("events: ", e.pageX)
    if ((e.changedTouches && e.changedTouches.length > 0) || e.pageX){
      if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PeRef.current,
          data
        )
      ) {
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        setInPe(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          QeRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        setInQe(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          QtRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQe(false);
        setInPb(false);
        setInPs(false);
        setInQt(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PbRef.current,
          data
        )
      ) {
        setInPb(true);
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPs(false);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PsRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(true);
      }
      else {
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        // setInPrice(false);
        // setInQuality(false);
      }
    }
  };

  const onDragUpdate = (e, data) => {
    e.preventDefault()
    console.log("events: ", e.pageX)
    if ((e.changedTouches && e.changedTouches.length > 0) || e.pageX){
      console.log("changedTouches", e.changedTouches, (e.pageX || e.changedTouches))
      // if(!e.pageX){
      //   return
      // }
      if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PeRef.current,
          data,e
        )
      ) {
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        setInPe(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          QeRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        setInQe(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          QtRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQe(false);
        setInPb(false);
        setInPs(false);
        setInQt(true);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PbRef.current,
          data
        )
      ) {
        setInPb(true);
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPs(false);
      } else if (
        checkIfInAnyBox(
          e.pageX || e.changedTouches[0].pageX,
          e.pageY || e.changedTouches[0].pageY,
          PsRef.current,
          data
        )
      ) {
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(true);
      }
      else {
        setInPe(false);
        setInQe(false);
        setInQt(false);
        setInPb(false);
        setInPs(false);
        // setInPrice(false);
        // setInQuality(false);
      }
    }
  };

  const checkIfInAnyBox = (x, y, element, data) => {
    if(!element){
      return false
    }
    // console.log("element", element)
    let targetX = element.offsetLeft;
    let targetY = element.offsetTop;
    let targetHeight = element.offsetHeight;
    let targetWidth = element.offsetWidth;
    let yCorrect = false
    let dataY = [[154, 220, 80], [230, 303, 174], [325, 404, 268]]
    // Iterate over each point in the array
    dataY.forEach((point) => {
      if (point[0] <= y && point[1] >= y && targetY === point[2]) {
        yCorrect = true;
      }
    });

    let xCorrect = 270 <= x - targetX && x - targetX <= 360
    // let dataX = [[990, 1080, 602], [1090, 1190, 708]]
    // // Iterate over each point in the array
    // dataX.forEach((point) => {
    //   if (280 <= x - targetX && x - targetX <= 350) {
    //     xCorrect = true;
    //   }
    // });
      console.log("data.node", element.getBoundingClientRect().x, data.node.getBoundingClientRect().x)
      const draggableRect = {
        x: data.node.getBoundingClientRect().x,
        y: data.node.getBoundingClientRect().y ,
        width: data.node.offsetWidth ,
        height: data.node.offsetHeight
      };
      console.log("targetX1= ",  targetX, x,  isColliding(draggableRect, element.getBoundingClientRect()))
    // }
    // console.log("targetX = ", y , targetY, targetX, y - targetY)
    // console.log(`x: ${x} >= targetX : ${targetX} and x: ${x} <= targetX + targetWidth: ${targetX + targetWidth} and y: ${y}  >= targetY: ${targetY} and y: ${y} < targetY + targetHeight: ${targetY + targetHeight}`)
    return isColliding(draggableRect, element.getBoundingClientRect())
    // if(isMobile){
    //   return (
    //     ((x - 60) >= targetX &&
    //     (x - 60) <= targetX + (targetWidth * 2) &&
    //     (y - 23) >= targetY &&
    //     (y - 23) < targetY + targetHeight) ||
    //     ((x - 60) >= targetX &&
    //     (x - 60) <= targetX + (targetWidth * 2)  &&
    //       (y - 23) > targetY - (targetWidth/2) &&
    //       (y - 23) < targetY + (targetWidth/2 + targetHeight)
    //       )
    //   );
    // }else{
    //   return (
    //     ( x - targetX >= 280 &&
    //       x - targetX <= 390  &&
    //       yCorrect
    //     )
    //     ||
    //     (
    //       y - targetY >= 15 &&
    //       y - targetY <= 100 &&
    //       xCorrect
    //     )
    //   );
    // }
  };

  const isColliding = (rect1, rect2) => {
    return !(
      rect1.x > rect2.x + rect2.width ||
      rect1.x + rect1.width < rect2.x ||
      rect1.y > rect2.y + rect2.height ||
      rect1.y + rect1.height < rect2.y
    );
  };

  function submitButtonAction() {
    console.log("submitButtonAction", step)
    // localStorage.setItem('step', 0)
    if(submit){
      if(allCorrect){
        return allCorrect ? "NEXT" : "TRY AGAIN"
      }else{
        // localStorage.setItem('step', step)
        // localStorage.setItem('answers', answers ? answers.join() : [])
        clearScreen()
        // window.location.reload(false)
      }
    }else{
      if(selected.length === 0 && step === 7){
        setIsOpen(true)
        console.log("open popup", step)
      }else{
        setSubmit(true)
      }
    }
  }

  return (
      <>
      <div className={classes.AppContainer} > {/* // onClick={() => [1,2].includes(step)  && nextStep()}> */}
        <div className={classes.innerContainer}>

          <div className={classes.leftContainer}>
            <div className={classes.headingContainer}>
              <h3
              className={`${step > 2 ? classes.headingText2 : `${classes.headingText1} animate__animated animate__bounceIn`}`}>
              A market is operating in perfect competition
              {step >=  2 ? ',' : '.'}
              {step >=  2 &&
              <span> then a $10 per unit tax is implemented on buyers, shown on the graph as a tax wedge.</span>
              }
              </h3>
            </div>
            {step < 2 ? 
            <Labels1
              step={step}
              draggedLabels={draggedLabels}
              onDragUpdate={onDragUpdate}
              onDragEnd={onDragEnd}
              setDraggableLabel={setDraggableLabel}
              PeRef={PeRef}
              QeRef={QeRef}
              inPe={inPe}
              inQe={inQe}
              peLabel={peLabel}
              qeLabel={qeLabel}
              submit={submit}
              onDragOffUpdate={onDragOffUpdate}
              onDragOffEnd={onDragOffEnd}
              screenSize={screenSize}
            />
            : <Labels2
              step={step}
              draggedLabels={draggedLabels}
              onDragUpdate={onDragUpdate}
              onDragEnd={onDragEnd}
              setDraggableLabel={setDraggableLabel}
              PeRef={PeRef}
              QeRef={QeRef}
              QtRef={QtRef}
              PbRef={PbRef}
              PsRef={PsRef}
              inPe={inPe}
              inQe={inQe}
              inQt={inQt}
              inPb={inPb}
              inPs={inPs}
              peLabel={peLabel}
              qeLabel={qeLabel}
              qtLabel={qtLabel}
              pbLabel={pbLabel}
              psLabel={psLabel}
              submit={submit}
              onDragOffUpdate={onDragOffUpdate}
              onDragOffEnd={onDragOffEnd}
              screenSize={screenSize}
            />}
            <DescriptionLines
            step={step} nextStep={nextStep}
            buyerTax={buyerTax}
            setBuyerTax={setBuyerTax}
            sellerTax={sellerTax} 
            setSellerTax={setSellerTax}
            isYes={isYes}
            setIsYes={setIsYes}
            isNo={isNo}
            setIsNo={setIsNo}
            submitted={submit}
            governmentRevenue={governmentRevenue}
            questionAnswer={questionAnswer}
            isCorrect={!getLabeltext()}
            questionNumber={questionNumber}
            descriptionText={descriptionText}
            setAnswers={setAnswers}
            answers={answers}
            setGovernmentRevenue={setGovernmentRevenue} />
          </div>

          {[0,1,2,6,7].includes(step) && submit && 
          <div className={classes.answerIconsContainer}>
            {!allCorrect ?
              <div className={classes.innerAnswerContainer}>
                <div  style={{ alignItems: "center", display: step === 6 ? "none" : "flex"}}>
                  <img src={crossIcon} alt="PriceLabel" className={classes.crossIcon}/>
                  <p className={classes.wrongLabelText}>{getLabeltext()}</p> 
                </div>
                <img src={Incorrect} alt="Incorrect" className={classes.Icon} />
              </div>
            : <img src={CorrectIcon} alt="CorrectIcon" className={classes.Icon} />
            }
          </div>
          }
        </div>
        <div style={{width: "30%", position: 'relative' }} className="animate__animated animate__bounceIn">
          { step < 2 ?
            <Graph1
              submitted={submit}
              setAnsweredCorrectly={() => console.log("setAnsweredCorrectly")}
              setAnsweredPartialy={() => console.log("setAnsweredPartialy")}
              questionAnswer={questionAnswer}
              setAnswers={setAnswers}
              answers={answers}
              step={step}
              selected={selected}
              setSelected={setSelected}
              setSubmit={setSubmit}
              questionNumber={questionNumber}
              // expose child function to the parent component
              resetStatesFun={childFunction => graph1Ref.current = childFunction}
            />
              // <NewGraph questionNumber={1} max={20}/>
            : <Graph2
            submitted={submit}
            setAnsweredCorrectly={() => console.log("setAnsweredCorrectly")}
            setAnsweredPartialy={() => console.log("setAnsweredPartialy")}
            questionAnswer={questionAnswer}
            setAnswers={setAnswers}
            answers={answers}
            step={step}
            selected={selected}
            setSelected={setSelected}
            setSubmit={setSubmit}
            governmentRevenue={governmentRevenue}
            questionNumber={questionNumber}
            // expose child function to the parent component
            resetStatesFun={childFunction => graph2Ref.current = childFunction}
          />
          }
          <Grid className={classes.submitContainer}>
            {
            (getButtonText() !== 'NEXT' && (step === 0 || step === 1 || step >= 6 || step === 2)) ? (
              <Grid style={{ display: 'flex', width: "100%", justifyContent: "space-between"}}>
                <button className={classes.submitButton} style={{ color: "#fff",backgroundColor: "#00b1d9", marginLeft: isMobile && -50 }} onClick={() => submitButtonAction() }>
                  {getButtonText()}
                </button>
                <button style={{ color: "#00b1d9", backgroundColor: "#fff", }} className={classes.submitButton} onClick={() => { clearScreen() }}>
                  CLEAR
                </button>
              </Grid>) : (step === 0 || step === 1 || step >= 6 || step === 2) && 
              <button style={{color: "#fff", backgroundColor: "#00b1d9" }} className={classes.nextButton} onClick={() => nextStep()}>{getButtonText()}</button>
            }
          </Grid>
        </div>
        <EvaluatorModal open={isOpen} setIsOpen={setIsOpen} />
      </div>
    </>
  )

}
export default withStyles(styles)(Question3);